import { Component, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IMedia } from 'app/core/models/media/media';
import { BaseComponent } from 'app/layout/common/base/base.component';

import { RenderMediaComponent } from 'app/layout/components/render-media/render-media.component';
import { ModalComponent } from '@kiwid-app/kiwid-ui-lib-angular';

@Component({
    selector: 'app-modal-preview-file',
    templateUrl: './modal-preview-file.component.html',
    styleUrls: ['./modal-preview-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RenderMediaComponent],
})
export class ModalPreviewFileComponent extends BaseComponent implements OnInit {
    public dialog: Signal<MatDialogRef<ModalComponent, string>>;
    public media: Signal<IMedia>;

    constructor() {
        super();
    }

    ngOnInit(): void {}
}
